function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React, { Children } from 'react';
import cn from 'classnames';
import { bool, node, string } from 'prop-types';
import Icon from '../../atoms/Icon';
/**
 * IconStack component.
 */

var IconStack = function IconStack(_ref) {
  var children = _ref.children,
      srOnly = _ref.srOnly,
      className = _ref.className,
      noAlign = _ref.noAlign;
  var icons = Children.toArray(children);
  var sizes = icons.map(function (icon) {
    return icon.props.size || 1;
  });
  var sizingUnits = icons.map(function (icon) {
    return icon.props.sizingUnit;
  });
  var groupSize = Math.max.apply(Math, _toConsumableArray(sizes));

  if (new Set(sizingUnits).size > 1) {
    throw new TypeError("Custom sizing units in an icon stack must all be set to the same value, got ".concat(sizingUnits));
  }

  return /*#__PURE__*/React.createElement("div", {
    className: cn('icon-stack', className, !noAlign && 'icon-stack--vertical-align'),
    style: {
      height: "".concat(groupSize).concat(sizingUnits[0]),
      width: "".concat(groupSize).concat(sizingUnits[0])
    }
  }, srOnly && /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, srOnly), icons.map(function (icon, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: "".concat(icon.props.name, "-").concat(icon.props.color, "-").concat(icon.props.size),
      className: "icon-stack__icon",
      style: {
        zIndex: icons.length - index
      }
    }, icon);
  }));
};

IconStack.defaultProps = {
  srOnly: null,
  className: null,
  noAlign: false
};
IconStack.propTypes = process.env.NODE_ENV !== "production" ? {
  /** The icons to be stacked. */
  children: node.isRequired,

  /** Hidden screen reader text. */
  srOnly: string,

  /** Additional class names to add to the component root. */
  className: string,

  /** Option to set whether the icon is vertically aligned */
  noAlign: bool
} : {};
IconStack.Icon = Icon;
export default IconStack;